export enum TestMode {
  Test = "test",
  Live = "live",
}
export type UserTypes =
  | "contractor"
  | "guest"
  | "puzzl_internal"
  | "puzzl_internal_guest"
  | "sole_co"
  | "white_label"
  | "wladmin"
  | "worker";

export interface ISiskoDefaultPageProps {
  readonly companyID: string;
  readonly isTestMode: boolean;
  readonly mode: TestMode;
  readonly userType: UserTypes;
}

export enum UserType {
  Contractor = "contractor",
  Employee = "Worker",
  Partner = "WhiteLabel",
  PartnerAdmin = "WhiteLabelAdmin",
  Company = "User",
  internationalContractor = "internationalContractor",
}

export type PayrollRunTypes = "regular" | "offCycle";
export type PayrollRunStatus =
  | "pending"
  | "submitted"
  | "incomplete"
  | "processed";

export enum EmploymentStatus {
  Live = "live",
  Leave = "leave",
  Terminated = "terminated",
}

type RNFormDataValue = string | { name?: string; type?: string; uri: string };

declare global {
  interface FormData {
    // to make it compatible with react-native
    // ref: https://github.com/facebook/react-native/issues/35698#issuecomment-1441579017
    // ref: https://github.com/facebook/react-native/blob/05438c33875283b01e321d8c1f3d6d3cf33946e5/Libraries/Network/FormData.js#L58
    append(name: string, value: string | Blob | RNFormDataValue): void;
  }
}
